<template>
  <div>
    <div class="msg-line" :class="message.from == fromUser ? 'msg-line-to' : 'msg-line-from'">
      <img alt="" class="msg-nick" src="../../assets/img/test2.jpg">
      <div class="msg-cont">
        <div v-if="message.from != fromUser" class="msg-cont-name">{{ message.fromNick }}<span>{{ formatDate(message.time) }}</span></div>
        <div @click.right="rightClick($event,message)" v-if="message.type === 'text'" class="msg-cont-word" v-html="contMatch(message)"></div>
        <div @click.right="rightClick($event,message)" v-if="message.type === 'image'" class="msg-cont-img">
          <el-image
              style="width: 100px;"
              :src="message.file.url"
              :preview-src-list="[message.file.url]">
          </el-image>
        </div>
        <a @click.right="rightClick($event,message)" v-if="message.type === 'file'" target="_blank" :href="message.file.url" class="msg-cont-file">
          <img v-if="'png,jpg,jpeg'.indexOf(message.file.ext) !== -1" class="msg-cont-file-img" src="@/assets/img/fileType/png.png" alt="">
          <img v-else-if="'xls,xlsx'.indexOf(message.file.ext) !== -1" class="msg-cont-file-img" src="@/assets/img/fileType/excel.png" alt="">
          <img v-else-if="'pdf'.indexOf(message.file.ext) !== -1" class="msg-cont-file-img" src="@/assets/img/fileType/pdf.png" alt="">
          <img v-else-if="'txt'.indexOf(message.file.ext) !== -1" class="msg-cont-file-img" src="@/assets/img/fileType/txt.png" alt="">
          <img v-else-if="'doc,docx'.indexOf(message.file.ext) !== -1" class="msg-cont-file-img" src="@/assets/img/fileType/word.png" alt="">
          <img v-else-if="'zip'.indexOf(message.file.ext) !== -1" class="msg-cont-file-img" src="@/assets/img/fileType/zip.png" alt="">
          <img v-else class="msg-cont-file-img" src="@/assets/img/fileType/unknow.png" alt="">
          <div>
            <div class="msg-cont-file-name">{{message.file.name}}</div>
            <div class="msg-cont-file-size">{{message.file.size / 1048576 > 1 ? (message.file.size / 1048576).toFixed(2) + 'M' : (message.file.size / 1024).toFixed(0) + 'KB' }}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import contMatch from "@/utils/contMatch"

export default {
  name: "ChatMessage",
  data(){
    return{
      rightMenuId:'',
      msgOptionPosition:[]
    }
  },
  props:{
    message:{
      type:Object
    },
    fromUser:'',
    toUser:''
  },
  mounted() {
    console.log(this.fromUser)
    console.log(this.toUser)
  },
  methods:{
    contMatch(data) {
      return contMatch(data)
    },
    formatDate(date) {
      let t = new Date(date).toLocaleString()
      return t.substring(0,t.length - 3)
    },
    rightClick(e,info){
      this.msgOptionPosition[0] = e.clientX
      this.msgOptionPosition[1] = e.clientY
      this.$emit('rightClick',this.msgOptionPosition,info)
    }
  }
}
</script>

<style scoped src="../../assets/css/chat.css">

</style>
